import { get } from 'lodash';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { RouteComponentProps } from 'react-router';

import { Leaderboard, PrizeInfo, Race } from '@swf/casino';
import Counter from '@swf/components/Counter/Counter';
import CloseButton, { Variant } from '@swf/components/StarsModal/components/CloseButton';
import Header from '@swf/components/StarsModal/components/Header/Header';
import { useWidget } from '@swf/core/hooks/useWidget';
import type { DefaultModel } from '@swf/core/models/widget';
import type { Dispatch } from '@swf/core/store';
import type { CasinoRace } from '@swf/core/types/CasinoRaces';
import { isLeaderboard } from '@swf/core/utils/casino';

import styles from './CasinoRaceLeaderboard.scss';

const CasinoRaceLeaderboard: React.FC<
  RouteComponentProps<object, object, { race: CasinoRace; widgetId: string; path: string }>
> = ({
  location: {
    state: { race, widgetId, path }
  }
}) => {
  const { modal } = useDispatch<Dispatch>();
  const { widgetSelect } = useWidget<void, DefaultModel>(widgetId);
  const data = useSelector(widgetSelect.get);
  const races: CasinoRace[] = get(data, path);
  const myRace = races.find((item) => item.id === race.id) || race;
  const { leaderboard, name, status } = myRace;
  const standings = leaderboard || [];

  return (
    <div className={styles.leaderboard}>
      <Header className={styles.header}>
        {name}
        <CloseButton variant={Variant.Light} />
      </Header>
      <div className={styles.raceContainer}>
        <Counter>
          {(count) => (
            <Race
              count={count}
              race={myRace}
              onLaunch={() => modal.close()}
              widgetId={widgetId}
              path={`${path}`}
            />
          )}
        </Counter>
      </div>
      <PrizeInfo prizeDetails={myRace.prizeDetails} />
      <Leaderboard
        race={myRace}
        className={styles.table}
        leaderboard={isLeaderboard(status)}
        standings={standings}
      />
    </div>
  );
};

export default CasinoRaceLeaderboard;
